import { Component, OnInit } from '@angular/core';
import { AuthService, Dropobj,MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';

import {Subject, Observable} from 'rxjs';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
  providers:[AuthService,MasterService]
})
export class RolesComponent implements OnInit { 

  // books: Book[];
   memberdetails:any[]=[];
   classdetails:any[]=[];
   issuedetails:any=[];
   closeResult: string;
   classes: Dropobj[];
   section: Dropobj[];
   student:boolean=true;
   staff:boolean=false;
   memberdash:any={};
   modalOptions:NgbModalOptions;
   private modalRef: NgbModalRef;
   private modalRef1: NgbModalRef;
   studentinfo:any={};
   arrgender=[{value:'M',name:'Male'},{value:'F',name:'Female'},{value:'O',name:'Other'}];
   arrmemtype=[{value:'S',name:'staff'},{value:'V',name:'visitor'}];

 
     
 objlink:any={};
 objstfdata:any={};
 stumemdata:any={};
 arrmnulst:any=[];
 arrrolesact:any=[];
 arrmnugrp:any=[];
 arrroleacdet:any=[];
 arrrolesall:any=[];
 objrole:any={};
 fileToUpload: File = null;
 defclass:any=0;
 selgrp:any=0;
 selrole:any=0;
 selmnu=''
 fData: FormData = new FormData;
 memid:any;
 memstusave=false;
 arrmnulinks:any=[];

 arrstatus=[{name:'YES'},{name:'NO'}];
 
 
   constructor(private http: HttpClient,private mservice:MasterService, private liservice: AuthService,private modalService: NgbModal) { }
 
 
   

 

   _keyPress(event: any) {
     if (event.charCode !== 0) {
       const pattern = /[0-9\+\-\ ]/;
       const inputChar = String.fromCharCode(event.charCode);
 
       if (!pattern.test(inputChar)) {
         // invalid character, prevent input
         event.preventDefault();
       }
     }
   }
 
   private getDismissReason(reason: any): string {
     if (reason === ModalDismissReasons.ESC) {
       return 'by pressing ESC';
     } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
       return 'by clicking on a backdrop';
     } else {
       return `with: ${reason}`;
     }
   }
 
 
 
   ngOnInit(): void {
     
     
     this.getrolesall();
     //this.getmnulinks();
   
  
   }
 
 
   
opensubject(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objrole={};
   
    
    
    this.objrole.roid=0;
    this.objrole.ronm='';
    this.objrole.rts='YES';
    this.objrole.active='YES';
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objrole.oprtype='insert';
   
  }

  else if(cmd=='update')
  {
    this.objrole=objdata;
    this.objrole.oprtype='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}
 
openlinkmdl(content) {
  this.selrole='';
  this.selgrp='';
  this.selmnu='';
  this.arrmnulinks={};
  this.getmnugrp();
  this.getrolesall();
 this.objlink={};
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}
 

Saverole()
{


this.liservice.saverole(this.objrole)
.subscribe((result:any) => {

alert (result.message);
console.log('arrinst',result);

if(result.status=='Success')
{
let localmodref=this.modalRef;
localmodref.close();
// this.getmemberdetails('selstu','');
this.getrolesall();

}
else
{

}
}, error => {

  alert ('error in saving');
}
);

}
 
 
updateper(obj)
{

  console.log('obj',obj);

this.liservice.updatepermission(obj)
.subscribe((result:any) => {

  this.getroledet(this.defclass);
console.log('arrinst',result);


}, error => {

  alert ('error in saving');
}
);

}
 

  
updatestatus(obj,status)
{

  console.log('obj',obj);

this.liservice.updatestatus(obj,status)
.subscribe((result:any) => {

  this.getroledet(this.defclass);
console.log('arrinst',result);


}, error => {

  alert ('error in saving');
}
);

}
 

   
   
  
  
  protected getrolesall() {
     this.liservice.getroles('selall')
         .subscribe(
         resultArray => {
             console.log('arrrolesall', resultArray);
             this.arrrolesall = resultArray;
           //  this.objstfdata.clid=resultArray[0].desid;
             //this.objstfdata.defblgrp=resultArray[0].blgpnm;
            
         },
         error => console.log("Error :: " + error)
         )
   }

   protected getrolesact() {
    this.liservice.getroles('selact')
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrrolesact = resultArray;
            this.defclass=resultArray[0].roid;
            this.getroledet(resultArray[0].roid);
          //  this.objstfdata.clid=resultArray[0].desid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  protected getmnugrp() {
    this.liservice.getmnugrp()
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrmnugrp = resultArray;
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  onmenuselect()
  {

    console.log('arrmnulinks',this.arrmnulinks);
  }

  protected getmnulinks(mid) {
    this.liservice.getmnulink(mid,this.selrole)
        .subscribe(
        resultArray => {
            console.log('getmnulink', resultArray);
            this.arrmnulinks = resultArray;
            this.arrmnulinks.map(function(entry) {
              entry.selected = false;
              
             
              return entry;
          });
           
        },
        error => console.log("Error :: " + error)
        )
  }

  protected getmnulst(roleid) {
    debugger;
    this.liservice.getmnulist(roleid)
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrmnulst = resultArray;
           
           
        },
        error => console.log("Error :: " + error)
        )
  }

  protected getroledet(roleid) {
    this.liservice.getroleaccessdet(roleid)
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrroleacdet = resultArray;
           
           
        },
        error => console.log("Error :: " + error)
        )
  }

 
   protected mashrmdept() {
    //  this.mservice.get_hrmdept()
    //      .subscribe(
    //      resultArray => {
    //          console.log('dept', resultArray);
    //          this.arrhrmdept = resultArray;
    //         //this.objstfdata.crsid=resultArray[0].depid;
    //          //this.objstfdata.defblgrp=resultArray[0].blgpnm;
            
    //      },
    //      error => console.log("Error :: " + error)
    //      )
   }
 
 
 
   assignmenu()
   {
    
  debugger
    
    var selbooks= this.arrmnulinks.filter(function(arr)
     {
 
       return arr.selected==true;
     })
     //var selbooks= this.arrmnulinks;


     if(selbooks.length==undefined || selbooks.length==0)
     {
   
       alert('Please select link from list ');
      
     }
 
     else
     {

     let clcd=localStorage.getItem('clcd');
     let aycd=localStorage.getItem('aycd');
     var selretbooks= selbooks.map( o => { return { mid: o.mid} });
     
     console.log('selbook-SAVE',selretbooks);
     
     var asgnmtdata = { roleid: this.selrole,mid:this.selmnu, clcd:clcd,aycd:aycd,arrmenus:selretbooks
     
   };
 
     console.log('asgnmtdata-SAVE', asgnmtdata);
     this.liservice.allocatemenu(asgnmtdata)
     .subscribe(result => {
         console.log('ret',JSON.stringify(result));
         alert (result.message);
         
    if(result.status=='Success')
 {
//    let localmodref=this.modalRef;
//  localmodref.close();

 this.getrolesact();
 //this.getlibtbkres();
 //this.Refreshsummary();
 
 }
 
 
 
      
     }, error => 
     {alert('error in connection');
 
  }
     
     );
   }
 
   
   }
 
 
 
 }
 
